export const Links: Record<string, any> = {
  SaveOnDuexis: 'https://www.duexis.com/patient/save-on-duexis',
  SaveOnPennsaid: 'https://www.pennsaid.com/start-saving',
  HorizonInfoEmail: 'mailto:HorizonCaresinfo@horizontherapeutics.com',
};
